import React, { ComponentType } from 'react'
import Loader from 'components/common/loader'
import useFirebaseMessaging from 'core/services/firebase/useFirebaseMessaging'

const withFirebaseMessaging = (
    ComposedComponent: ComponentType<any>,
    loader: React.ReactNode = <Loader />,
) => {
    const WithFirebaseMessaging: React.FC<any> = ({ ...props }) => {
        useFirebaseMessaging()
        return <ComposedComponent {...props} />
    }
    return WithFirebaseMessaging
}

export default withFirebaseMessaging
